import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

//  http://wiki.xunlei.cn/pages/viewpage.action?pageId=127573173
export const activity_homepage = createAsyncThunk(
  'live/vip/vip_activity',
  async (arg, store: any) => {
    const resp = await http.post('live/vip/vip_activity', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export enum StatusEnum {
  进行中 = 1,
  已结束 = 2,
  未开始 = 3,
}
export interface InitialStateType {
  list: Array<{
    status: StatusEnum
    banner: string
    name: string
    start: string
    end: string
    url: string
  }>
}

const initialState: InitialStateType = {
  list: [],
}

export const VipActivitySlice = createSlice({
  name: 'VipActivitySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(activity_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default VipActivitySlice.reducer
export const VipActivityActions = VipActivitySlice.actions

export const useVipActivityState = () => {
  const data = useSelector((state) => {
    return state.VipActivity
  })
  return data
}
